import { createFileRoute, Outlet } from "@tanstack/react-router";
import { OrganisationLayout } from "~/pages/Settings/Organisations/organisation/OrganisationLayout";

export const Route = createFileRoute(
  "/_app/settings/organisations/$organisationId",
)({
  component: OrganisationRoute,
});

function OrganisationRoute() {
  const { organisationId } = Route.useParams();

  return (
    <OrganisationLayout organisationId={organisationId}>
      <Outlet />
    </OrganisationLayout>
  );
}
